import { render, staticRenderFns } from "./portalGenerateAnswerSkeleton.vue?vue&type=template&id=c3b1df74&scoped=true&lang=pug"
import script from "./portalGenerateAnswerSkeleton.vue?vue&type=script&lang=js"
export * from "./portalGenerateAnswerSkeleton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3b1df74",
  null
  
)

export default component.exports